import React, { useState, useEffect, useRef } from 'react';

const MEETING_TYPES = [
  'Setting',
  'Closing Terminierung ausstehend',
  'Closing terminiert',
  'Feedback ausstehend',
  'abgesagt',
  'verkauft',
  'on hold',
];
const REMINDER_UNITS = ['Minuten vorher', 'Stunden vorher', 'Tage vorher'];

function toDateStr(d) { return d.toISOString().slice(0, 10); }
function getMondayOfWeek(d) {
  const dt = new Date(d);
  const day = dt.getDay();
  const diff = (day === 0 ? -6 : 1 - day);
  dt.setDate(dt.getDate() + diff);
  dt.setHours(0, 0, 0, 0);
  return dt;
}
const DAYS_DE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
const MONTHS_DE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
const MONTHS_FULL = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

function WeekCalendar({ startDate, startTime, endTime, hideWeekends, weekOffset, setWeekOffset, onSlotClick, meetings = [] }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const baseMonday = getMondayOfWeek(new Date());
  const monday = new Date(baseMonday);
  monday.setDate(monday.getDate() + weekOffset * 7);

  const dayCount = hideWeekends ? 5 : 7;
  const days = Array.from({ length: dayCount }, (_, i) => {
    const d = new Date(monday);
    d.setDate(d.getDate() + i);
    return d;
  });

  const startHour = 7;
  const endHour = 22;
  const hours = Array.from({ length: endHour - startHour }, (_, i) => startHour + i);

  const weekLabel = (() => {
    const end = days[days.length - 1];
    return `${days[0].getDate()}. ${MONTHS_DE[days[0].getMonth()]}–${end.getDate()}. ${MONTHS_DE[end.getMonth()]}, ${days[0].getFullYear()}`;
  })();

  const selectedDateStr = startDate;
  const selectedStartMin = startTime ? parseInt(startTime.split(':')[0]) * 60 + parseInt(startTime.split(':')[1]) : null;
  const selectedEndMin   = endTime   ? parseInt(endTime.split(':')[0])   * 60 + parseInt(endTime.split(':')[1])   : null;

  function handleCellClick(day, hour) {
    const mm = String(hour).padStart(2, '0');
    onSlotClick(toDateStr(day), `${mm}:00`, `${String(hour + 1).padStart(2, '0')}:00`);
  }

  const nowMin = today.getTime() === new Date(new Date().toISOString().slice(0,10)).getTime()
    ? new Date().getHours() * 60 + new Date().getMinutes()
    : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>
      {/* Calendar toolbar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px 8px', flexShrink: 0, borderBottom: '1px solid #deeae0' }}>
        <button onClick={() => setWeekOffset(0)} style={{ fontSize: 12, fontWeight: 500, color: '#17382a', background: '#eef4fb', border: '1px solid #c8d6cb', borderRadius: 6, padding: '3px 10px', cursor: 'pointer' }}>Heute</button>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#17382a', flex: 1, textAlign: 'center' }}>{weekLabel}</div>
        <button onClick={() => setWeekOffset(w => w - 1)} style={{ background: 'none', border: '1px solid #c8d6cb', borderRadius: 6, padding: '3px 8px', cursor: 'pointer', color: '#5e7a68' }}>‹</button>
        <button onClick={() => setWeekOffset(w => w + 1)} style={{ background: 'none', border: '1px solid #c8d6cb', borderRadius: 6, padding: '3px 8px', cursor: 'pointer', color: '#5e7a68' }}>›</button>
      </div>

      {/* Day headers */}
      <div style={{ display: 'grid', gridTemplateColumns: `44px repeat(${dayCount}, 1fr)`, flexShrink: 0, borderBottom: '1px solid #deeae0', background: '#f7faf7' }}>
        <div />
        {days.map((d, i) => {
          const isToday = toDateStr(d) === toDateStr(today);
          const isSel   = toDateStr(d) === selectedDateStr;
          return (
            <div key={i} style={{ padding: '6px 4px', textAlign: 'center' }}>
              <div style={{ fontSize: 11, color: '#5e7a68' }}>{DAYS_DE[i]}</div>
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: isToday ? '#ef4444' : isSel ? '#159c5f' : 'transparent', color: isToday ? '#fff' : isSel ? '#fff' : '#17382a', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '2px auto 0' }}>
                {d.getDate()}
              </div>
            </div>
          );
        })}
      </div>

      {/* Time grid */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {hours.map(hour => (
          <div key={hour} style={{ display: 'grid', gridTemplateColumns: `44px repeat(${dayCount}, 1fr)`, borderBottom: '1px solid #f0f5f0', minHeight: 40 }}>
            <div style={{ fontSize: 10, color: '#93a89a', padding: '2px 6px 0', textAlign: 'right', paddingRight: 8, paddingTop: 2 }}>{String(hour).padStart(2,'0')}:00</div>
            {days.map((d, di) => {
              const dayStr = toDateStr(d);
              const isSel = dayStr === selectedDateStr && selectedStartMin !== null && selectedStartMin >= hour * 60 && selectedStartMin < (hour + 1) * 60;
              const isSelSpan = dayStr === selectedDateStr && selectedStartMin !== null && selectedEndMin !== null && hour * 60 >= selectedStartMin && hour * 60 < selectedEndMin;

              const dayMeetings = meetings.filter(m => m.date === dayStr && m.startHour === hour);

              return (
                <div key={di}
                  onClick={() => handleCellClick(d, hour)}
                  style={{
                    borderLeft: '1px solid #f0f5f0', minHeight: 40, cursor: 'pointer', position: 'relative',
                    background: isSelSpan ? 'rgba(29,190,116,0.12)' : 'transparent',
                    transition: 'background .1s',
                  }}
                  onMouseEnter={e => { if (!isSelSpan) e.currentTarget.style.background = '#f0f7ff'; }}
                  onMouseLeave={e => { if (!isSelSpan) e.currentTarget.style.background = 'transparent'; }}
                >
                  {isSel && (
                    <div style={{ position: 'absolute', inset: '2px 3px', background: '#159c5f', borderRadius: 4, fontSize: 10, color: '#fff', padding: '2px 4px', fontWeight: 600, overflow: 'hidden' }}>
                      {startTime} {endTime}
                    </div>
                  )}
                  {dayMeetings.map((m, mi) => (
                    <div key={mi} style={{ position: 'absolute', inset: '2px 3px', background: '#8f7cc9', borderRadius: 4, fontSize: 10, color: '#fff', padding: '2px 4px', overflow: 'hidden' }}>
                      {m.title}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function FloatingMeeting({ lead, meetings = [], currentUser, onSave, onClose }) {
  const today = new Date().toISOString().slice(0, 10);
  const nowH  = new Date().getHours();
  const defStart = `${String(nowH + 1).padStart(2,'0')}:00`;
  const defEnd   = `${String(nowH + 2).padStart(2,'0')}:00`;

  const [title,       setTitle]       = useState('');
  const [startDate,   setStartDate]   = useState(today);
  const [startTime,   setStartTime]   = useState(defStart);
  const [endTime,     setEndTime]     = useState(defEnd);
  const [meetingType, setMeetingType] = useState('');
  const [location,    setLocation]    = useState('');
  const [reminders,   setReminders]   = useState([{ val: '1', unit: 'Stunden vorher' }]);
  const [description, setDescription] = useState('');
  const [hideWeekends, setHideWeekends] = useState(true);
  const [weekOffset,  setWeekOffset]  = useState(0);
  const [pos, setPos] = useState({ x: Math.max(40, window.innerWidth / 2 - 500), y: Math.max(40, window.innerHeight / 2 - 360) });

  const dragging = useRef(false);
  const dragOff  = useRef({ x: 0, y: 0 });

  useEffect(() => {
    function onMove(e) { if (!dragging.current) return; setPos({ x: e.clientX - dragOff.current.x, y: e.clientY - dragOff.current.y }); }
    function onUp()   { dragging.current = false; }
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
  }, []);

  function startDrag(e) {
    if (e.target.closest('button, input, select, textarea, label')) return;
    dragging.current = true;
    dragOff.current = { x: e.clientX - pos.x, y: e.clientY - pos.y };
    e.preventDefault();
  }

  function addReminder() { setReminders(r => [...r, { val: '1', unit: 'Tage vorher' }]); }
  function removeReminder(i) { setReminders(r => r.filter((_, ri) => ri !== i)); }
  function updateReminder(i, key, val) { setReminders(r => r.map((rem, ri) => ri === i ? { ...rem, [key]: val } : rem)); }

  function handleSlotClick(date, sTime, eTime) {
    setStartDate(date);
    setStartTime(sTime);
    setEndTime(eTime);
  }

  function handleSave() {
    const startISO = new Date(`${startDate}T${startTime}`).toISOString();
    const endISO   = new Date(`${startDate}T${endTime}`).toISOString();
    const parts    = startDate.split('-');
    onSave({
      id: Date.now(),
      type: 'meeting',
      title: title || 'Meeting',
      meetingType: meetingType || 'Vorort-Besuch',
      date: `${parts[2]}.${parts[1]}.${parts[0]}`,
      dateISO: startDate,
      startTime,
      endTime,
      startISO,
      endISO,
      location,
      reminders,
      description,
      lead: lead ? { id: lead.id, name: lead.name, company: lead.company } : null,
      by: currentUser?.name || 'Robin Obrecht',
      month: new Date(startDate).toLocaleDateString('de-DE', { month: 'long', year: 'numeric' }),
    });
    onClose();
  }

  return (
    <div style={{
      position: 'fixed', left: pos.x, top: pos.y, zIndex: 500,
      width: 980, height: 620,
      background: '#fff', borderRadius: 10,
      border: '1px solid #c8d6cb',
      boxShadow: '0 12px 56px rgba(15,30,60,0.2)',
      display: 'flex', flexDirection: 'column',
      overflow: 'hidden', fontFamily: 'var(--font)',
    }}>
      {/* Header */}
      <div onMouseDown={startDrag} style={{ background: '#17382a', padding: '10px 14px', cursor: 'grab', userSelect: 'none', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>Meeting planen</span>
          {lead && <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.65)', background: 'rgba(255,255,255,0.1)', borderRadius: 20, padding: '2px 8px' }}>{lead.name}</span>}
        </div>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      {/* Body: left form + right calendar */}
      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>

        {/* Left form */}
        <div style={{ width: 340, flexShrink: 0, borderRight: '1px solid #deeae0', display: 'flex', flexDirection: 'column', overflowY: 'auto', padding: '16px' }}>

          {/* Title */}
          <div style={{ marginBottom: 14 }}>
            <div style={lb}>Titel</div>
            <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Meeting-Titel..." style={{ ...inp, width: '100%', boxSizing: 'border-box' }}
              onFocus={e => e.target.style.borderColor = '#159c5f'} onBlur={e => e.target.style.borderColor = '#c8d6cb'} />
          </div>

          {/* Date / Times */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 14 }}>
            <div>
              <div style={lb}>Startdatum</div>
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={inp} />
            </div>
            <div>
              <div style={lb}>Startzeit</div>
              <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} style={inp} />
            </div>
            <div>
              <div style={lb}>Endzeit</div>
              <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} style={inp} />
            </div>
          </div>

          {/* Type + Attendees */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
            <div>
              <div style={lb}>Meeting-Typ</div>
              <select value={meetingType} onChange={e => setMeetingType(e.target.value)} style={{ ...inp, cursor: 'pointer', width: '100%' }}>
                <option value="">auswählen…</option>
                {MEETING_TYPES.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <div style={lb}>Teilnehmer</div>
              <div style={{ ...inp, display: 'flex', alignItems: 'center', color: '#159c5f', fontWeight: 500, cursor: 'default' }}>Robin Obrecht</div>
            </div>
          </div>

          {/* Location */}
          <div style={{ marginBottom: 14 }}>
            <div style={lb}>Standort</div>
            <input value={location} onChange={e => setLocation(e.target.value)} placeholder="Adresse oder Link..." style={{ ...inp, width: '100%', boxSizing: 'border-box' }}
              onFocus={e => e.target.style.borderColor = '#159c5f'} onBlur={e => e.target.style.borderColor = '#c8d6cb'} />
          </div>

          {/* Reminders */}
          <div style={{ marginBottom: 14 }}>
            <div style={lb}>Geplante Erinnerungs-E-Mails</div>
            {reminders.map((r, i) => (
              <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6 }}>
                <input type="number" min="1" value={r.val} onChange={e => updateReminder(i, 'val', e.target.value)}
                  style={{ ...inp, width: 52, textAlign: 'center' }} />
                <select value={r.unit} onChange={e => updateReminder(i, 'unit', e.target.value)} style={{ ...inp, flex: 1, cursor: 'pointer' }}>
                  {REMINDER_UNITS.map(u => <option key={u}>{u}</option>)}
                </select>
                <button onClick={() => removeReminder(i)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#93a89a', padding: '0 2px' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
                </button>
              </div>
            ))}
            <button onClick={addReminder} style={{ fontSize: 12, color: '#159c5f', background: 'none', border: 'none', cursor: 'pointer', padding: '2px 0', fontWeight: 500 }}>+ Erinnerung hinzufügen</button>
          </div>

          {/* Description */}
          <div style={{ marginBottom: 16 }}>
            <div style={lb}>Teilnehmerbeschreibung</div>
            <textarea value={description} onChange={e => setDescription(e.target.value)}
              placeholder="Senden Sie eine Beschreibung an Ihre Teilnehmer…"
              rows={3}
              style={{ ...inp, height: 'auto', padding: '8px 10px', resize: 'vertical', lineHeight: 1.5, width: '100%', boxSizing: 'border-box' }}
              onFocus={e => e.target.style.borderColor = '#159c5f'} onBlur={e => e.target.style.borderColor = '#c8d6cb'} />
          </div>

          {lead && (
            <div style={{ fontSize: 12, color: '#5e7a68', marginBottom: 14, padding: '6px 10px', background: '#eef4fb', borderRadius: 6, border: '1px solid #c8d6cb' }}>
              <span style={{ fontWeight: 600 }}>2 Datensätze zugeordnet</span> · {lead.name}, {lead.company}
            </div>
          )}

          {/* Footer buttons */}
          <div style={{ display: 'flex', gap: 8, marginTop: 'auto' }}>
            <button onClick={onClose} style={{ flex: 1, height: 36, borderRadius: 7, background: '#f0f5f0', border: '1px solid #c8d6cb', color: '#e05a2b', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Abbrechen</button>
            <button onClick={handleSave} disabled={!title} style={{ flex: 2, height: 36, borderRadius: 7, background: title ? '#159c5f' : '#e2ebe3', border: 'none', color: title ? '#fff' : '#93a89a', fontSize: 13, fontWeight: 600, cursor: title ? 'pointer' : 'default' }}>
              Meeting planen
            </button>
          </div>
        </div>

        {/* Right: calendar */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          {/* Calendar options bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 16px', borderBottom: '1px solid #deeae0', background: '#f7faf7', flexShrink: 0 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#17382a', cursor: 'pointer' }}>
              <input type="checkbox" checked={hideWeekends} onChange={e => setHideWeekends(e.target.checked)} />
              Wochenenden ausblenden
            </label>
            <div style={{ marginLeft: 'auto', fontSize: 11, color: '#93a89a' }}>UTC +02:00 (Europa) Mitteleuropäische Zeit</div>
          </div>
          <WeekCalendar
            startDate={startDate}
            startTime={startTime}
            endTime={endTime}
            hideWeekends={hideWeekends}
            weekOffset={weekOffset}
            setWeekOffset={setWeekOffset}
            onSlotClick={handleSlotClick}
            meetings={meetings}
          />
        </div>
      </div>
    </div>
  );
}

const lb  = { fontSize: 11, fontWeight: 600, color: '#5e7a68', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 };
const inp = { height: 32, borderRadius: 6, border: '1.5px solid #c8d6cb', padding: '0 10px', fontSize: 12, outline: 'none', background: '#fff', color: '#17382a', fontFamily: 'var(--font)', boxSizing: 'border-box', transition: 'border-color .15s' };
